export default interface SettingsRepository {
    getCurrentTheme(): string;
    setCurrentTheme(theme: string): void;
}

export const SettingsRepositoryName = "SettingsRepository";